export interface EitriApp {
    id: string;
    createdAt: string;
    updatedAt: string;
    name: string;
    title: string;
    publicKey: string;
    slug: string;
    status: EitriAppStatus;
    organizationId: string;
    applicationId: string;
    users: EitriAppUser[];
    appGroupId: string;
}

export enum EitriAppStatus {
    "ACTIVE" = "ACTIVE",
    "INACTIVE" = "INACTIVE"
}

interface EitriAppUser {
    id: string;
    role: EitriAppRole;
    email: string;
}

enum EitriAppRole {
    "DEVELOPER" = "DEVELOPER",
    "PRODUCT_OWNER" = "PRODUCT_OWNER",
    "EITRI_APP_ADMIN" = "EITRI_APP_ADMIN"
}
